import { QuestionTypeChip, type QuestionTypeChipProps } from '@exam-management/components';
import { Flex, Text } from '@shared/components';

type QuestionTypeLabelProps = QuestionTypeChipProps;

export default function QuestionTypeLabel(props: Readonly<QuestionTypeLabelProps>) {
  return (
    <Flex
      sx={{
        p: (theme) => theme.spacing(4),
        gap: (theme) => theme.spacing(3),
        alignItems: 'center',
      }}
    >
      <Text>Question Type:</Text>
      <QuestionTypeChip {...props} />
    </Flex>
  );
}
